<template>
  <v-app class="container">
    <br />
    <v-card>
      <v-card-title
        v-if="gpreguntasfrecuentes.length <= 0"
        class="grey lighten-4 change-font"
        primary-title
      >
        <div class="spinner-grow"></div>Cargando preguntas frecuentes &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>Preguntas frecuentes</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Escriba una palabra clave para la búsqueda de información"
          single-line
          hide-details
          @keyup="filtrar"
        ></v-text-field>
        <br />
        <v-expansion-panels v-model="panel">
          <v-expansion-panel v-for="pregunta in preguntas" :key="pregunta.idpreguntafrecuente">
            <v-expansion-panel-header>{{pregunta.pregunta}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <template>
                <div v-html="body(pregunta.respuestahtml)"></div>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-app>
</template>      
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      panel: null,
      search: "",
      preguntas: []
    };
  },
  computed: {
    ...mapGetters(["gpreguntasfrecuentes"])
  },
  methods: {
    ...mapActions(["get_preguntasfrecuentes"]),
    filtrar() {
      if (this.search !== "") {
        this.preguntas = this.gpreguntasfrecuentes.filter(
          p =>
            p.preguntafiltro
              .toUpperCase()
              .indexOf(this.search.toUpperCase()) !== -1 ||
            p.respuestafiltro
              .toUpperCase()
              .indexOf(this.search.toUpperCase()) !== -1 ||
            p.pregunta.toUpperCase().indexOf(this.search.toUpperCase()) !==
              -1 ||
            p.respuesta.toUpperCase().indexOf(this.search.toUpperCase()) !== -1
        );
      } else {
        this.preguntas = this.gpreguntasfrecuentes;
      }
    },
    body: function(cuerpo) {
      var slot = this.$slots.default;
      if (typeof slot !== "undefined") {
        return slot;
      } else if (typeof cuerpo !== "undefined") {
        return cuerpo;
      } else return null;
    }
  },
  created() {
    this.get_preguntasfrecuentes();
  },
  watch: {
    gpreguntasfrecuentes  : function( ){
      this.preguntas = this.gpreguntasfrecuentes;
    }
  }
};
</script>